import { gql } from '__generated__';

export default gql(`
  query GetTickets($project_id: ID!, $event_id: ID!) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        title
        start_date
        ticket_categories {
          id
          title
          sport_type
          start_date
          capacity
          deletable
          checkout_url
          locale
          translations {
            ...TranslationFields
          }
          tickets {
            id
            title
            units
            promotions {
              id
              amount
              start_date
              end_date
              active
            }
            sold_count
            capacity
            invitation_reservations_count
            active
            is_sold_out
            has_usable_invitations
            deletable
          }
        }
      }
    }
    distanceUnits
  }
`);
